<script>
  import List from './GridList.svelte';
  import Edit from './GridBuilder.svelte';

  export let items = [];
  let active = 'list';
  let editId = {};
  const handleClick = (tabValue) => () => (active = tabValue);
  const editItem = (e) => {
    editId = e.detail;
    active = 'edit';
  };
</script>

{#if active == 'edit'}
  <div class="box">
    <svelte:component this={Edit} on:back={handleClick('list')} data={editId} />
  </div>
{:else}
  <div class="box">
    <svelte:component this={List} on:editItem={editItem} {items} />
  </div>
{/if}
